import { TRANS } from "./classes";
import { DefaultIfEmptyString } from "./classes";
import { NullValueDefiner } from "./classes";

export class CMP {
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם

    public static compare_strings(p_str1: string, p_str2: string, p_NULL_IS_UP: boolean): number {
        // השוואת מחרוזות רגילה
        // AI פונקציה זו נכתבה על ידי
        //debugger;
        const str1_trimed = p_str1.trim();
        const str2_trimed = p_str2.trim();
        const exist1: boolean = (str1_trimed != "");
        const exist2: boolean = (str2_trimed != "");

        /*
        if (exist1 == false || exist2 == false) {
            console.log(`str1_trimed="${str1_trimed}", str2_trimed="${str2_trimed}""`);
        }
        */

        if (exist1 == false && exist2 == false) {
            return 0; // equals
        }
        if (exist1 == false && exist2 == true) {
            //debugger;
            if (p_NULL_IS_UP == true) {
                //console.log(`null is up`);
                return (-1);
            }
            else {
                //console.log(`null is down`);
                return (+1);
            }
        }
        if (exist1 == true && exist2 == false) {
            //debugger;
            if (p_NULL_IS_UP == true) {
                console.log(`null is up`);
                return (+1);
            }
            else {
                console.log(`null is down`);
                return (-1);
            }
        }
        if (exist1 == true && exist2 == true) {
            return str1_trimed.localeCompare(str2_trimed, "he");
        }
        return 0;
    }

    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם

    public static compare_numbers_as_strings(p_num1_as_str: string, p_num2_as_str: string, p_NULL_IS_UP: boolean): number {
        // השוואת מחרוזות שמכילות מספרים
        // AI פונקציה זו נכתבה על ידי
        const str1_trimed = p_num1_as_str.trim();
        const str2_trimed = p_num2_as_str.trim();
        const exist1: boolean = (str1_trimed != "");
        const exist2: boolean = (str2_trimed != "");
        debugger;

        if (exist1 == false && exist2 == false) {
            return 0; // equals
        }
        if (exist1 == false && exist2 == true) {
            debugger;
            if (p_NULL_IS_UP == true) {
                return (-1);
            }
            else {
                return (+1);
            }
        }
        if (exist1 == true && exist2 == false) {
            debugger;
            if (p_NULL_IS_UP == true) {
                return (+1);
            }
            else {
                return (-1);
            }
        }
        if (exist1 == true && exist2 == true) {
            const num1: number = Number(str1_trimed);
            const num2: number = Number(str2_trimed);
            if (!isNaN(num1) && !isNaN(num2)) {
                return num1 - num2;
            }
            else {
                return 0; // לא ברור לי מה צריך להחזיר כאן
            }

        }
        return 0;
    }
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם


    public static compare_booleans_as_strings(p_bool1_as_str: string, p_bool2_as_str: string, p_NULL_IS_UP: boolean): number {

        const str1_trimed = p_bool1_as_str.trim();
        const str2_trimed = p_bool2_as_str.trim();
        const exist1: boolean = (str1_trimed != "");
        const exist2: boolean = (str2_trimed != "");
        debugger;

        if (exist1 == false && exist2 == false) {
            return 0; // equals
        }
        if (exist1 == false && exist2 == true) {
            debugger;
            if (p_NULL_IS_UP == true) {
                return (-1);
            }
            else {
                return (+1);
            }
        }
        if (exist1 == true && exist2 == false) {
            debugger;
            if (p_NULL_IS_UP == true) {
                return (+1);
            }
            else {
                return (-1);
            }
        }
        if (exist1 == true && exist2 == true) {
            const bval1 = TRANS.trans_string_to_bool(str1_trimed, DefaultIfEmptyString.Unknown);
            const bval2 = TRANS.trans_string_to_bool(str2_trimed, DefaultIfEmptyString.Unknown);
            const num1: number = TRANS.trans_boolean_to_0_or_1_as_number(bval1);
            const num2: number = TRANS.trans_boolean_to_0_or_1_as_number(bval2);
            if (!isNaN(num1) && !isNaN(num2)) {
                return num1 - num2;
            }
            else {
                return 0; // לא ברור לי מה צריך להחזיר כאן
            }

        }
        return 0;
    }

    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם


    public static compare_datons_V1_as_strings(p_daton1_str: string, p_daton2_str: string, p_NULL_IS_UP: boolean): number {
        // לתאריכים יכולים להיות מספר פורמטים פונקציה זו מתאימה לפורמט הבא
        // V1 = 17/4/2026 i.ie 17 April 2026
        // V1 = 17/4/2026 i.ie 17 April 2026
        // V1 = 17/4/2026 i.ie 17 April 2026
        //const str1: string = num1_as_str.trim();
        //const str2: string = num2_as_str.trim();
        const str1_trimed = p_daton1_str.trim();
        const str2_trimed = p_daton2_str.trim();
        const exist1: boolean = (str1_trimed != "");
        const exist2: boolean = (str2_trimed != "");
        //------------------------------------------
        if (exist1 == false && exist2 == false) {
            return 0; // equals
        }
        if (exist1 == false && exist2 == true) {
            if (p_NULL_IS_UP == true) {
                return (-1);
            }
            else {
                return (+1);
            }
        }
        if (exist1 == true && exist2 == false) {
            if (p_NULL_IS_UP == true) {
                return (+1);
            }
            else {
                return (-1);
            }
        }
        if (exist1 == true && exist2 == true) {
            const daton1: number = TRANS.trans_daton_string_to_daton_int_v1(str1_trimed);
            const daton2: number = TRANS.trans_daton_string_to_daton_int_v1(str2_trimed);
            const diff: number = (daton1 - daton2);
            return diff;
        }
        return 0;
        //------------------------------------------
    }

    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם

    public static compare_homins_V1_as_strings(p_homin1_str: string, p_homin2_str: string, p_NULL_IS_UP: boolean): number {
        // לתאריכים יכולים להיות מספר פורמטים פונקציה זו מתאימה לפורמט הבא
        // V1 = 17/4/2026 i.ie 17 April 2026
        // V1 = 17/4/2026 i.ie 17 April 2026
        // V1 = 17/4/2026 i.ie 17 April 2026
        const str1_trimed = p_homin1_str.trim();
        const str2_trimed = p_homin2_str.trim();
        const exist1: boolean = (str1_trimed != "");
        const exist2: boolean = (str2_trimed != "");
        //------------------------------------------
        if (exist1 == false && exist2 == false) {
            return 0; // equals
        }
        if (exist1 == false && exist2 == true) {
            if (p_NULL_IS_UP == true) {
                return (-1);
            }
            else {
                return (+1);
            }
        }
        if (exist1 == true && exist2 == false) {
            if (p_NULL_IS_UP == true) {
                return (+1);
            }
            else {
                return (-1);
            }
        }
        if (exist1 == true && exist2 == true) {
            const homin1: number = TRANS.trans_homin_string_to_homin_int_v1(str1_trimed);
            const homin2: number = TRANS.trans_homin_string_to_homin_int_v1(str2_trimed);
            const diff: number = (homin1 - homin2);
            return diff;
        }
        return 0;
        //------------------------------------------



    }

    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם


    public static compare_percentages_as_strings(p_precentage1_str: string, p_precentage2_str: string, p_NULL_IS_UP: boolean): number {
        // מחרוזות שמכילות אחוזים
        const str1_trimed = p_precentage1_str.trim();
        const str2_trimed = p_precentage2_str.trim();
        const exist1: boolean = (str1_trimed != "");
        const exist2: boolean = (str2_trimed != "");
        //------------------------------------------
        if (exist1 == false && exist2 == false) {
            return 0; // equals
        }
        if (exist1 == false && exist2 == true) {
            if (p_NULL_IS_UP == true) {
                return (-1);
            }
            else {
                return (+1);
            }
        }
        if (exist1 == true && exist2 == false) {
            if (p_NULL_IS_UP == true) {
                return (+1);
            }
            else {
                return (-1);
            }
        }
        if (exist1 == true && exist2 == true) {
            const num1: number = Number(str1_trimed.replace("%", "").trim());
            const num2: number = Number(str2_trimed.replace("%", "").trim());
            return num1 - num2;
        }
        return 0;
        //------------------------------------------



    }

    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם

    public static aux_function_get_ratio_value(str: string, p_NULL_IS_UP: boolean): number {
        const parts: string[] = str.split("/");
        const current: number = Number(parts[0].trim());
        const total: number = Number(parts[1].trim());
        if (total === 0) {
            return 0;
        }
        return current / total;
    }

    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
    // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם

    public static compare_ratios_as_strings(p_ration1_str: string, p_ration2_str: string, p_NULL_IS_UP: boolean): number {
        // examples for ratio: "1/5", "2/10" 
        const str1_trimed = p_ration1_str.trim();
        const str2_trimed = p_ration2_str.trim();
        const exist1: boolean = (str1_trimed != "");
        const exist2: boolean = (str2_trimed != "");
        //------------------------------------------
        if (exist1 == false && exist2 == false) {
            return 0; // equals
        }
        if (exist1 == false && exist2 == true) {
            if (p_NULL_IS_UP == true) {
                return (-1);
            }
            else {
                return (+1);
            }
        }
        if (exist1 == true && exist2 == false) {
            if (p_NULL_IS_UP == true) {
                return (+1);
            }
            else {
                return (-1);
            }
        }
        if (exist1 == true && exist2 == true) {
            const ratio1: number = CMP.aux_function_get_ratio_value(str1_trimed, p_NULL_IS_UP);
            const ratio2: number = CMP.aux_function_get_ratio_value(str2_trimed, p_NULL_IS_UP);
            return ratio1 - ratio2;
        }
        return 0;
        //------------------------------------------

        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם



    }

}

